import { render, staticRenderFns } from "./PensionListe.vue?vue&type=template&id=5b2af07c&"
import script from "./PensionListe.vue?vue&type=script&lang=js&"
export * from "./PensionListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports